const pearl = {
  title: 'Pearl',
  tips: 'Please check the withdrawal information and the amount',
  notice:
    'Cancellations are not allowed after submission. Please check and confirm the accuracy of the account details and amount.',
  selectUserTips: 'Enter the amount to withdraw',
};

const information = {
  title: 'Information',
  inputPlaceholder: 'Enter',
};

export default {
  title: 'Withdraw',
  success: 'Withdraw successfully',
  successTips1: 'The request will take 3 - 7 working days to process. Please be patient.',
  successTips2:
    'If the official review is rejected, you will receive a notification and the amount will be refunded.',
  withdrawInformation: 'Withdraw Information',
  placeholder: 'Enter the amount to withdraw',
  fee: 'Fee: {{count}}%',
  pearl,
  information,
};
